import script from "./CollectFolderList.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectFolderList.vue?vue&type=script&setup=true&lang=js"

import "./CollectFolderList.vue?vue&type=style&index=0&id=10a2e108&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a2e108"]])

export default __exports__